import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormsServiceService } from '../../../api/services/forms-service.service';

@Component({
  selector: 'app-input-field-with-label-above',
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './input-field-with-label-above.component.html',
  styleUrls: ['./input-field-with-label-above.component.css'],
})
export class InputFieldWithLabelAboveComponent {
  @Input() formGroup!: FormGroup;
  @Input() fields: any;
  @Input() disableFields: any;
  @Input() autoFocused: any;
  errors: { [key: string]: string } = {};
  @ViewChild('focusInput') focusInput!: ElementRef<HTMLInputElement>;
  constructor(private formService: FormsServiceService) {}
  ngOnInit() {}

  ngOnChanges() {
    if (!this.autoFocused) return;

    setTimeout(() => {
      this.focusInput?.nativeElement.focus();
    });
  }

  get control() {
    return this.formGroup?.get(this.fields.fieldName);
  }

  /** Function to show the validation error message on enter of the text */
  onKeyUpValidateFields(field: any): void {
    const fieldName = field.fieldName;
    const control = this.formGroup.get(fieldName);
    if (!control) return;
    control.markAsTouched();
    control.updateValueAndValidity({ emitEvent: false });
    this.errors[fieldName] = '';
    if (control.hasError('required')) {
      return;
    }
    if (control.hasError('minlength')) {
      const minLengthRule = field.validationRules?.find(
        (v: any) => v.type.toLowerCase() === 'minlength',
      );
      this.errors[fieldName] =
        minLengthRule?.error ||
        `Minimum length is ${control.errors?.['minlength']?.requiredLength}.`;
      return;
    }

    if (control.hasError('maxlength')) {
      const maxLengthRule = field.validationRules?.find(
        (v: any) => v.type.toLowerCase() === 'maxlength',
      );
      this.errors[fieldName] =
        maxLengthRule?.error ||
        `Maximum length is ${control.errors?.['maxlength']?.requiredLength}.`;
      return;
    }

    if (control.hasError('pattern')) {
      const regexRule = field.validationRules?.find(
        (v: any) => v.type.toLowerCase() === 'regex',
      );
      this.errors[fieldName] = regexRule?.error || 'Invalid format.';
      return;
    }

    if (control.hasError('email')) {
      this.errors[fieldName] = 'Enter a valid email address.';
      return;
    }

    if (control.hasError('min')) {
      const minRule = field.validationRules?.find(
        (v: any) => v.type.toLowerCase() === 'min',
      );
      this.errors[fieldName] =
        minRule?.error || `Minimum value is ${control.errors?.['min']?.min}.`;
      return;
    }

    if (control.hasError('max')) {
      const maxRule = field.validationRules?.find(
        (v: any) => v.type.toLowerCase() === 'max',
      );
      this.errors[fieldName] =
        maxRule?.error || `Maximum value is ${control.errors?.['max']?.max}.`;
      return;
    }

    this.errors[fieldName] = '';
  }

  getRuleValue(field: any, type: string): number | null {
    const rule = field.validationRules?.find(
      (v: any) => v.type?.toLowerCase() === type.toLowerCase(),
    );
    return rule?.value ?? null;
  }
}
